import React from 'react';

const LoadingButton = ({
  children,
  loading,
  loadingText = 'Loading...',
  disabled,
  className = '',
  spinnerClass = 'h-5 w-5',
  ...props
}) => {
  return (
    <button
      disabled={loading || disabled}
      className={`w-full flex items-center justify-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-white font-medium shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
      {...props}
    >
      {loading && (
        <svg
          className={`animate-spin ${spinnerClass} text-white`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"
          />
        </svg>
      )}
      {loading ? loadingText : children}
    </button>
  );
};

export default LoadingButton;
